export default {};
throw new Error(`Could not resolve "gsap/SplitText" imported by "@appletosolutions/reactbits". Is it installed?`)